/**
 * 商家端 - 代销合作（发起邀约 + 列表）
 */

import { useState } from 'react'
import { Card, Table, Button, Badge, useApi, formatScope } from '../../components/ui'
import { HelpBubble } from '../../components/HelpBubble'
import { api } from '../../api/client'

interface Partnership {
  partnership_id: string
  factory_id: string
  commission_rate: string
  product_scope: unknown
  valid_from: string
  valid_to: string
  status: string
  signed_at: string | null
}

export function SellerPartnerships() {
  const list = useApi<Partnership[]>(async () => api.get('/partnerships'), [])
  const [showForm, setShowForm] = useState(false)

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>代销合作</h2>
        <Button onClick={() => setShowForm((v) => !v)}>发起邀约</Button>
      </div>

      {showForm && <InviteForm onDone={() => list.refresh()} />}

      <Card title={`合作关系（${list.data?.length ?? 0}）`}>
        <Table<Partnership>
          rows={list.data ?? []}
          empty={list.loading ? '加载中...' : '暂无合作'}
          columns={[
            { key: 'partnership_id', title: '合作ID' },
            { key: 'factory_id', title: '工厂' },
            {
              key: 'commission_rate',
              title: '佣金率',
              render: (r) => `${(parseFloat(r.commission_rate) * 100).toFixed(1)}%`,
            },
            { key: 'product_scope', title: '范围', render: (r) => formatScope(r.product_scope) },
            { key: 'valid', title: '有效期', render: (r) => `${r.valid_from} ~ ${r.valid_to}` },
            { key: 'status', title: '状态', render: (r) => <Badge status={r.status} /> },
          ]}
        />
      </Card>

      <HelpBubble pageKey="seller-partnerships" title="代销合作">
        <p>商家与工厂是<b>多对多</b>关系：一个商家可以和多个工厂合作，一个工厂也可以给多个商家供货。</p>
        <p>点「发起邀约」向工厂发起合作。佣金率=商家服务费占比（如 0.4=商家拿 40% 服务费）。工厂接受后合作生效，才能下单。</p>
      </HelpBubble>
    </div>
  )
}

function InviteForm({ onDone }: { onDone: () => void }) {
  const [factoryId, setFactoryId] = useState('demo-factory-01')
  const [rate, setRate] = useState(0.4)
  const [from, setFrom] = useState('2026-01-01')
  const [to, setTo] = useState('2027-12-31')
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  async function submit() {
    setLoading(true)
    setErr('')
    try {
      await api.post('/partnerships', {
        factoryId,
        commissionRate: rate,
        validFrom: from,
        validTo: to,
        productScope: ['服装'],
      })
      onDone()
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card title="发起合作邀约">
      <div style={{ display: 'grid', gap: 8, maxWidth: 400 }}>
        <label>
          工厂ID：<input value={factoryId} onChange={(e) => setFactoryId(e.target.value)} style={inputStyle} />
        </label>
        <label>
          佣金率(0-1)：<input type="number" step="0.01" value={rate} onChange={(e) => setRate(parseFloat(e.target.value))} style={inputStyle} />
        </label>
        <label>
          生效起：<input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={inputStyle} />
        </label>
        <label>
          生效止：<input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={inputStyle} />
        </label>
        <Button onClick={submit} disabled={loading}>
          {loading ? '提交中...' : '提交邀约'}
        </Button>
        {err && <div style={{ color: '#dc2626' }}>{err}</div>}
        <div style={{ color: '#888', fontSize: 12 }}>提示：佣金率 0.4 = 商家拿 40% 服务费</div>
      </div>
    </Card>
  )
}

const inputStyle: React.CSSProperties = {
  padding: '6px 10px',
  border: '1px solid #d1d5db',
  borderRadius: 4,
  width: '100%',
  marginLeft: 8,
}
